export default function NoReviewsView({ onConnect }) {
  return (
    <div className="space-y-8">
      {/* Header Section */}
      <div className="space-y-4">
        <h2 className="text-3xl font-semibold text-gray-800">You haven't received any reviews yet.</h2>
        <p className="text-gray-600 max-w-2xl">
          You haven't received any patient reviews yet—but that's normal when you're just getting started. 
          The Shift platform is designed to help you build trust gradually and consistently.
        </p>
      </div>

      {/* Four Cards Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Step 1 */}
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <p className="text-sm text-gray-500 mb-3">Step 1</p>
          <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
            <div className="w-8 h-8 bg-yellow-400 rounded-full"></div>
          </div>
          <h3 className="font-semibold text-gray-800 mb-3">Turn on Review Prompts</h3>
          <p className="text-sm text-gray-600 mb-4">
            Automate review requests via text/email—help patients share their experience with ease.
          </p>
          <button className="bg-blue-900 text-white text-sm px-3 py-1.5 rounded-lg flex items-center gap-2 hover:bg-blue-800 transition-colors">
            <span>Activate</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Step 2 */}
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <p className="text-sm text-gray-500 mb-3">Step 2</p>
          <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
            <div className="w-8 h-8 bg-red-400 rounded"></div>
          </div>
          <h3 className="font-semibold text-gray-800 mb-3">Download In-Office Flyers</h3>
          <p className="text-sm text-gray-600 mb-4">
            Use QR posters and front-desk cards to guide patients to your review page.
          </p>
          <button className="bg-blue-900 text-white text-sm px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-800 transition-colors">
            <span>Download</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Step 3 */}
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <p className="text-sm text-gray-500 mb-3">Step 3</p>
          <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center mb-4">
            <div className="w-8 h-8 bg-pink-400 rounded-full"></div>
          </div>
          <h3 className="font-semibold text-gray-800 mb-3">Ask for Reviews the Right Way</h3>
          <p className="text-sm text-gray-600 mb-4">
            Want more 5-star reviews? It starts with the right ask. Download our guide here.
          </p>
          <button className="bg-blue-900 text-white text-sm px-3 py-1.5 rounded-lg flex items-center gap-2 hover:bg-blue-800 transition-colors">
            <span>Download</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Google Connect */}
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 via-red-500 to-yellow-500 rounded-lg flex items-center justify-center mb-4">
            <span className="text-white font-bold text-lg">G</span>
          </div>
          <h3 className="font-semibold text-gray-800 mb-3">Connect Your Business Profile now</h3>
          <button 
            onClick={onConnect}
            className="bg-blue-900 text-white text-sm px-3 py-1.5 rounded-lg flex items-center gap-2 hover:bg-blue-800 transition-colors"
          >
            <span>Connect</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Footer Help Section */}
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <div className="w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center">
          <span className="text-gray-500 text-xs">?</span>
        </div>
        <span>Need Help?</span>
        <button className="text-blue-600 underline hover:text-blue-800 bg-transparent border-none p-0 cursor-pointer">Send us a message.</button>
      </div>
    </div>
  );
}
